import { useEffect, useState } from 'react';

// Service
import ArchingService from '../../services/ArchingService';

const useArching = (archingId) => {
    const [arching, setArching] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getFromServer = () => {
            setLoading(true);
            ArchingService
                .GetByArchingId(archingId)
                .then(res => {
                    setArching({
                        ...res
                    });
                })
                .finally(() => setLoading(false))
        }

        if (archingId) getFromServer();
    }, [archingId]);

    return {
        arching,
        loading,
    };
}

export default useArching;
